"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatOrgName = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

/**
 * Attempts to format the organization information to friendlyName if set in branding settings.
 * If it does not exist, it will use the fallback.
 * @param org
 * @param fallback
 */
var formatOrgName = function formatOrgName(org, fallback) {
  if (!org) {
    return fallback;
  }

  if ((0, _typeof2.default)(org) !== "object") {
    throw new Error("Organization settings must be an object. You may have accidentally supplied organization name.");
  }

  if (!org.settings || !org.settings.brandingSettings) {
    return fallback;
  }

  var name = org.settings.brandingSettings.friendlyName;

  if (!name && !fallback) {
    return org ? org.name : "Unknown Organization";
  }

  return name || fallback;
};

exports.formatOrgName = formatOrgName;